// @flow

import React from 'react';
import { connect } from 'react-redux';
import NewsOverview from './newsOverview';
import { getLatestArticlesLabel } from '../../../store/newsSettings';
import { getNewsItems } from '../../../store/news';
import type { NewsItem } from '../../../types';

type StateProps = {|
  items?: Array<NewsItem>,
  latestArticlesLabel: string,
|};

const NewsOverviewContainer = ({ items, latestArticlesLabel }: StateProps) => (
  <>
    { items
      && <NewsOverview
        latestArticlesLabel={latestArticlesLabel}
        items={items}
      />}
  </>
);

NewsOverviewContainer.defaultProps = {
  items: [],
};

const mapStateToProps = (state): StateProps => ({
  items: getNewsItems(state, 1),
  latestArticlesLabel: getLatestArticlesLabel(state),
});

export default connect<any, void, StateProps, any, any, any>(
  mapStateToProps,
)(NewsOverviewContainer);
